module.exports = {
  servicesHostName: 'https://app.eatdindin.com/api/'
}
